import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, ModalHeader, ModalBody, Table } from "reactstrap";

import { responseApi, selectAllResponse } from '../../reducers/responseSlice';
import { clearResponseMediaList } from '../../reducers/responseMediaSlice';
import ResponseListItem from "./ResponseListItem";
import moment from 'moment-timezone';

const ResponsePopup = ({survey, onToggle}) => {
  
    const responses = useSelector((state) => selectAllResponse(state));
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(responseApi.fetchAll({surveyId: survey.id}))

        return () => { dispatch(clearResponseMediaList()) }
    }, [dispatch, survey])

    const onModalToggle = () => {
        onToggle(null)
    }

    const formatDate = (dateString) => {
        let desiredFormat = "YYYY-MM-DD HH:mm:ss";
        let timeToBeConverted = moment(dateString, desiredFormat);
        let timeZone = "Europe/Rome";

        return dateString ? timeToBeConverted.tz(timeZone).format(desiredFormat) : <span className="text-light">in sospeso</span>;
    }

    return (
        <Modal
            isOpen={true}
            size="xl"
            toggle={() => { onModalToggle() }}
        >
            <ModalHeader toggle={() => { onModalToggle() }}>
                <h2 className="pl-3"><b>{survey.name}</b> <span className="font-12">({ survey.closed_at ? formatDate(survey.closed_at) : "-" })</span></h2> 
            </ModalHeader>
            <ModalBody>
                <Table responsive hover>
                    <thead>
                        <tr>
                            <th style={{width: '99%'}}>Domanda</th>
                            {/* <th><i className="fas fa-sticky-note"></i></th>
                            <th><i className="fa fa-image"></i></th> */}
                            <th style={{width: '1%', whiteSpace: 'nowrap'}}>Data</th>
                            <th style={{width: '1%'}}>Risposta</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            responses.length > 0
                                ? responses.map((response) => (
                                    <ResponseListItem surveyId={survey.id} response={response} key={response.id} />
                                ))
                                : <tr><td>Non ci sono risposte</td><td>-</td></tr>
                        }
                    </tbody>
                </Table>
            </ModalBody>
        </Modal>
    );
};

export default ResponsePopup;